const appID = "566"; // real = 249

const useCreate = () => {
  return { appID };
};

export type Props = ReturnType<typeof useCreate>;

export default useCreate;
